import { useGetCompanyHandler } from '@commenda/api';
import { Avatar, Button } from '@commenda/kakashi';
import { CompanyHandlerType } from '@prisma/client';
import { useConfig } from 'context/useConfig';
import { useAccountManagerCallEnabled } from 'hooks/useAccountManagerCallEnabled';
import { useRouter } from 'next/router';

const FALLBACK_HANDLER = {
  name: 'Sidharth Rao',
  email: 'sid@commenda.io',
  meetingCalendarLink:
    'https://calendly.com/sidharth-commenda/catch-up-with-sid-clone',
};

export const PointOfContact = () => {
  const { companyId } = useConfig();
  const { enabled: callEnabled } = useAccountManagerCallEnabled(companyId);
  const router = useRouter();

  const { data } = useGetCompanyHandler({
    companyIds: companyId ? [companyId] : [],
    type: CompanyHandlerType.ACCOUNT_MANAGER,
  });

  const handler = data?.handlers?.[0] ?? FALLBACK_HANDLER;
  const { name } = handler;
  const image = 'image' in handler ? handler.image : undefined;
  const meetingLink =
    'meetingCalendarLink' in handler
      ? handler.meetingCalendarLink
      : undefined;

  return (
    <div className="flex flex-col gap-xl p-xl bg-bg-primary border border-border-secondary rounded-xl shadow-xs">
      <span className="font-mulish text-md font-bold leading-6 text-text-primary">
        Point of contact
      </span>
      <div className="flex gap-md items-center">
        {image ? (
          <div className="shrink-0 size-10 rounded-full border border-border-primary overflow-hidden">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={image}
              alt={name}
              referrerPolicy="no-referrer"
              className="size-full object-cover"
            />
          </div>
        ) : (
          <Avatar
            size="md"
            name={name}
            className="shrink-0 !rounded-full !border border-border-primary"
          />
        )}
        <div className="flex flex-col flex-1 min-w-0 justify-center">
          <span className="font-mulish text-sm font-bold leading-5 text-text-primary">
            {name}
          </span>
          <span className="font-mulish text-xs font-normal leading-[15px] text-text-secondary">
            Account Manager
          </span>
        </div>
        {callEnabled
          ? meetingLink && (
              <Button
                size="sm"
                variant="secondary"
                onClick={() => window.open(meetingLink, '_blank')}
                className="shrink-0"
              >
                Schedule a call
              </Button>
            )
          : (
              <Button
                size="sm"
                variant="secondary"
                onClick={() => router.push('/inbox?thread=general')}
                className="shrink-0"
              >
                Message
              </Button>
            )}
      </div>
    </div>
  );
};
